import React, { useRef } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import Solution from '../components/Solution';
import HowItWorks from '../components/HowItWorks';
import Proof from '../components/Proof';
import ForWho from '../components/ForWho';
import ClosingCTA from '../components/ClosingCTA';
import Footer from '../components/Footer';

const LandingPage = () => {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero onRequestDemo={scrollToForm} />
        <Problem />
        <Solution />
        <HowItWorks />
        <Proof />
        <ForWho />
        <ClosingCTA formRef={formRef} />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
